import SummariesView from "@features/tools/view/summaries-view";

const Summaries = () => {
  return <SummariesView />;
};

export default Summaries;
